import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createCity = ( {data} : {data: IPostNewCity | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/Cities/InsertCity`, data);
};

type QueryFnType = typeof createCity;

type UseCreateCityOptions = {
  data: IPostNewCity | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateCity = ({ config }: UseCreateCityOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Πόλης.`, 500);
            console.error('Couldnt create new area', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllCities"])
            addNotification(`Δημιουργήθηκε Νέα Πόλη.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createCity,
    })
}